// extracted by css-extract-rspack-plugin
export default {"widgetAddressView":"widget-address-view--pLx9WqCVNwm8GYzW","widgetAddressViewMagritte":"widget-address-view-magritte--BdmGydz9R2scIf7W"};